import React, { useState } from 'react';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import Spinner from '../../components/layout/Spinner';
import TechnologyForm from '../../components/technologys/TechnologyForm';
import { convertToFormData } from '../../shared/upload';
import {
  initialValues,
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from '../../shared/enums/technologys_enum';
import {
  useUpdateTechnology,
  useSingleTechnology,
  useGetDropdownOptions,
} from '../../shared/hooks/UseTechnology';
import api from '../../domain/api';
// import { useSelectAllTechnology } from "../../shared/hooks/UseTechnology";

const EditTechnology = ({ match }) => {
  let history = useHistory();
  const [single_data] = useSingleTechnology(match.params.id);
  const [updateData] = useUpdateTechnology();
  const { technology_loading, technology, edit_technology_loading } =
    single_data;
  const [featuredImage, setFeaturedImage] = useState(null);

  const [dropdownOptions, loadOptions] = useGetDropdownOptions();
  const submitFormClicked = async (values) => {
    const data = await convertToFormData({ values, featuredImage });
    // await updateData(technology._id, data);
    await api.put(`/${LINK_URL}/${technology._id}`, values);

    history.push(`/${LINK_URL}/${technology._id}/view`);
  };

  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={`Edit ${PAGE_SINGLE_TITLE}`}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink='Edit'
        />
      </div>
      <div className='container-fluid'>
        <div className='col-lg-12'>
          <div className='card'>
            {!technology_loading ? (
              technology && (
                <div>
                  <div className='card-header'>
                    <div>
                      <h4 className='card-title'>
                        {technology[Object.keys(inputFields)[0]]} -{' '}
                        <span>Edit</span>{' '}
                      </h4>
                      <p className='card-title-desc'>
                        <Link
                          to={`/${LINK_URL}`}
                          className='btn btn-soft-light'
                        >
                          <i className='fa fa-angle-left'></i> {PAGE_TITLE}
                        </Link>
                        <Link
                          to={`/${LINK_URL}/${technology._id}/view`}
                          className='btn btn-soft-light'
                        >
                          <i className='fa fa-eye'></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <TechnologyForm
                    data={technology}
                    edit={true}
                    featuredImage={featuredImage}
                    setFeaturedImage={setFeaturedImage}
                    submitForm={submitFormClicked}
                    inputFields={inputFields}
                    initialValues={initialValues}
                    dropdown_options={dropdownOptions}
                    loading={edit_technology_loading}
                    loadOptions={loadOptions}
                  />
                </div>
              )
            ) : (
              <div className='text-center'>
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTechnology;
